<div class="page-title">
  <h1>Notificações</h1>
</div>

<div class="active-tag">
  <button [ngClass]="{'active-btn': isNotificacoesActive}" (click)="toggleActiveScreen(true)">
    Notificações
    <div class="notificacoes-count-badge" *ngIf="unreadNotificacoesCount > 0">{{ unreadNotificacoesCount }}</div>
  </button>
  <button [ngClass]="{'active-btn': !isNotificacoesActive}" (click)="toggleActiveScreen(false)">
    Avisos
    <div class="avisos-count-badge" *ngIf="unreadAvisosCount > 0">{{ unreadAvisosCount }}</div>
  </button>
</div>

<app-notificacoes-list *ngIf="isNotificacoesActive"></app-notificacoes-list>
<app-avisos-list *ngIf="!isNotificacoesActive"></app-avisos-list>
